<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="imgVideoAudio1==3">
            <audio-style 
                style="width:180px;float:left"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.audioPlayTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="imgVideoAudio1==3">
            点击音频部分播放，并作答
        </el-col>
        <el-col :span="13" class="imgStyle videoShowBox" v-if="[1,2].includes(imgVideoAudio1)" align="left">
            <div class="stateBice">
                <div class="haveGotOnTheBus" v-if="imgVideoAudio1==2">
                    <div class="busBoxVideo">
                        <p v-if="heart.videoPlayTime!=-1">剩余次数：X{{plays}}</p>
                        <video
                            :class="['textAudioUrl','videoTopicSty',heart.videoPlayTime!=-1?'videoDisYesNum':'',videoDis? 'videoDisStyle':'']"
                            id="video"
                            :ref="'videoRef'+serial"
                            :src="heart.questionDto.detailInfo.videoUrl"
                            @click="videoClick"
                            :controls="plays==0?false:true"
                            controlslist="nodownload nofullscreen noplaybackrate noremoteplayback"
                            preload="Metadata"
                            :disablePictureInPicture="true"
                            @play="videoPlay($event)"
                            @ended="vodepEnded()"
                        ></video>
                    </div>
                </div>
                <!-- controls -->
                <div  class="haveGotOnTheBus" v-else-if="imgVideoAudio1==1">
                    <img class="imgStyleUrl" :src="heart.questionDto.detailInfo.questionImgUrl" v-viewer alt="" srcset="">
                </div>
                <div class="playTheDrumsLeft" v-else></div>
            </div>
        </el-col>
        <el-col 
            :span="[1,2].includes(imgVideoAudio1)? 11:24"
            :class="['imgStyle',[1,2].includes(imgVideoAudio1)?'imgStyleRight':'imgStyleW100']"
            :style="{height:imgVideoAudio1==0?'100%':''}"
            align="left"
        >
            <div class="stateBice1" id="inputBoss">
                <el-input
                    type="textarea"
                    id="textArea"
                    ref="textBicel"
                    class="vimText"
                    placeholder="请在此处输入文字答题（粘贴已禁用）"
                    v-model="viewVal"
                    maxlength="5000"
                    show-word-limit
                    resize="none"
                    @focus="jupeFocus()"
                    @paste.native.capture.prevent="handleFalse"
                    @change="changeViewVal"
                >
                </el-input>
            </div>
        </el-col>
    </div>
</template>
<script>
import updataImg from '../../components/updataImg'
import utils from '../../lib/util'
import audioStyle from '../../components/audioStyle'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"creativeTopic",
        props: {
            sonData: Object,
            allAnswer:Object,
            examMinTime:Number,
            serial:Number,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                viewVal:'',
                maxImg:'',
                isInput:false,
                timers:null,
                answerType:null,
                imgVideoAudio1:0,
                plays:0,
                videoDis:false,
            }
        },
        components:{
            updataImg,audioStyle
        },
        watch: {
            'viewVal':function(now,old){
                if(now.length>0&&this.answerType)this.answerType = null
                this.$emit('storeLocally')
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            },
            'plays':function(now,old){
                this.$emit('storeLocally')
            },
            'examMinTime':function(now,old){
                if(now<=0&&now!=-1){
                    this.$refs.textBicel.blur();
                    this.isInput = true
                }
            }
        },
        computed:{},
        created(){},
        beforeDestroy() {
            window.clearInterval(this.timers)
        },
        mounted(){
            this.heart = this.sonData
            this.$nextTick(function(){
                if(this.heart.questionDto.detailInfo.videoUrl)this.imgVideoAudio1 = 2
                if(this.heart.questionDto.detailInfo.audioUrl)this.imgVideoAudio1 = 3
                if(this.heart.questionDto.detailInfo.questionImgUrl)this.imgVideoAudio1 = 1
                this.plays = this.imgVideoAudio1==2? utils.mottoClone(this.heart.videoPlayTime):utils.mottoClone(this.heart.audioPlayTime)
                if(this.allAnswer){
                    this.viewVal = this.allAnswer.obj.viewVal
                    this.answerType = this.allAnswer.obj.answerType
                    this.plays = this.allAnswer.playss
                }
            })
        },
        methods:{
            //禁止黏贴
            handleFalse() {
                //终止
                return false;
            },
            jupeFocus(){
                if(this.isInput)
                this.$refs.textBicel.blur();
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            },
            changeViewVal(){
                this.$nextTick(()=>{
                    wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                        allData:this.$parent.allData,
                        uuid1:this.$parent.uuid1,
                        firstStartDateVal:this.$parent.firstStartDateVal,
                    })
                })
            },
            getPlays(){
                //限定播放次数
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.audioPlayTime)
            },
            startPlaying(){
                
            },
            endPlaying(){
                if(this.plays<=0) this.plays=0
                else this.plays--;
            },
            endAudio(){
                if(this.heart.questionDto.detailInfo.audioUrl){
                    if(!this.$refs.audioRef.judgePaying()){
                        this.endPlaying()
                    }
                    this.$refs.audioRef.endAudio()
                }else if(this.heart.questionDto.detailInfo.videoUrl){
                    this.endVideoPlaying()
                }
            },
            vodepEnded(){
                this.videoDis = false
            },
            videoPlay(e){
                if(e) e.target.blur()
                if(this.plays>0){
                    this.videoDis = true
                    this.plays--;
                } 
                else if(this.plays==0)
                this.plays=0
            },
            endVideoPlaying(){
                eval("this.$refs.videoRef" +this.serial).pause()
                eval("this.$refs.videoRef" +this.serial).currentTime = 0
                this.videoDis = false
            },
            videoClick(){
                if(this.plays==0)
                this.$message.error('该视频播放次数已用完');
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        position: relative;
        .videoShowBox{
            position: absolute;
            left: 0;
            width: 50%;
            height: 100%;
        }
        .centSty{
            position: absolute;
            right: 0;
            width: 50%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            height: 100%;
            .stateBice{
                height: 100%;
                width: 100%;
                .haveGotOnTheBus{
                    height: 100%;
                    width: 95%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    .textAudioUrl{
                        max-width: 100%;
                        max-height: 100%;
                        display: block !important;
                        margin: auto;
                    }
                    .busBoxVideo{
                        display: inline-block;
                    }
                    .busBoxVideo p{
                        font-size: 13px;
                        text-align: right;
                    }
                    .imgStyleUrl{
                        max-height: 100%;
                        max-width: 100%;
                    }
                    .playNum{
                        float: left;
                        display: inline-block;
                        height: 33px;
                        width: 100px;
                        .playNumIng{
                            display: inline-block;
                            img{
                                margin: 5px 0 0 15px;
                                vertical-align: text-bottom;
                            }
                        }
                    }
                }

            }
            .stateBice1{
                width: 100%;
                height: 100%;
                max-height: 100%;
                position: relative;
                // 输入
                .vimText{
                    position: absolute;
                    top: 0%;
                    left: 0%;
                    right: 0%;
                    bottom: 0%;
                }
            }
        } 
        .imgStyleW100{
            width: 100%;
            height: 90%;
            box-sizing: border-box;
            padding: 25px 18px;
            overflow-y: auto;
        }
        .imgStyleRight{
            position: absolute;
            right: 0;
            width: 50%;
            height: 100%;
        } 
    }
</style>
<style>
    #inputBoss .vimText{}
    #inputBoss .vimText .el-textarea__inner{
        /* height: 100% !important; */
        min-height: 100% !important;
        /* min-height: 234px !important; */
        border-color:#1E4BB0;
    }
    #textArea::-webkit-input-placeholder{
        /* line-height: 220px; */
        text-align: left;
        color: #1E4BB0;
    }
    .videoTopicSty::-webkit-media-controls-fullscreen-button {
        display: none;
    }
    .videoTopicSty::-webkit-media-controls-toggle-closed-captions-button {
        display: none;
    }

    .videoDisStyle::-webkit-media-controls-play-button {
        display: none;
    }

    .videoDisYesNum::-webkit-media-controls-timeline {
        /* display: none; */
        pointer-events: none;
    }

    /* .videoTopicSty::-webkit-media-controls-current-time-display {
        display: none;
    } */

    /* .videoTopicSty::-webkit-media-controls-time-remaining-display {
        display: none;
    } */

    /* .videoTopicSty::-webkit-media-controls-mute-button {
        display: none;
    } */

    /* .videoTopicSty::-webkit-media-controls-enclosure {
        display: none;
    } */

    /* .videoTopicSty::-webkit-media-controls-volume-slider {
        display: none;
    } */
</style>


// WEBPACK FOOTER //
// src/components/exam/videoTopic.vue